var _path, _path2, _path3, _path4, _path5, _g, _g2, _g3, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _g4, _path40, _path41, _path42, _path43, _path44, _path45, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _path46, _path47, _path48, _path49, _path50, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFluentEmojiBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.375 6.86553V6.25928L10.5 1.25928L18.625 6.25928V6.86553H2.375Z",
    fill: "url(#paint0_linear_3786_77308)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.375 6.86553V6.25928L10.5 1.25928L18.625 6.25928V6.86553H2.375Z",
    fill: "url(#paint1_linear_3786_77308)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.375 6.86553V6.25928L10.5 1.25928L18.625 6.25928V6.86553H2.375Z",
    fill: "url(#paint2_linear_3786_77308)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.375 6.86553V6.25928L10.5 1.25928L18.625 6.25928V6.86553H2.375Z",
    fill: "url(#paint3_radial_3786_77308)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.375 6.86553V6.25928L10.5 1.25928L18.625 6.25928V6.86553H2.375Z",
    fill: "url(#paint4_linear_3786_77308)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_3786_77308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.89062 5.71558L9.63438 1.50308C10.1594 1.17183 10.8344 1.17183 11.3594 1.50308L18.1031 5.71558V6.89683L10.9156 2.43433C10.6594 2.27808 10.3406 2.27808 10.0844 2.43433L2.89687 6.89683V5.71558H2.89062Z",
    fill: "url(#paint5_linear_3786_77308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.89062 5.71558L9.63438 1.50308C10.1594 1.17183 10.8344 1.17183 11.3594 1.50308L18.1031 5.71558V6.89683L10.9156 2.43433C10.6594 2.27808 10.3406 2.27808 10.0844 2.43433L2.89687 6.89683V5.71558H2.89062Z",
    fill: "url(#paint6_linear_3786_77308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.89062 5.71558L9.63438 1.50308C10.1594 1.17183 10.8344 1.17183 11.3594 1.50308L18.1031 5.71558V6.89683L10.9156 2.43433C10.6594 2.27808 10.3406 2.27808 10.0844 2.43433L2.89687 6.89683V5.71558H2.89062Z",
    fill: "url(#paint7_radial_3786_77308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.89062 5.71558L9.63438 1.50308C10.1594 1.17183 10.8344 1.17183 11.3594 1.50308L18.1031 5.71558V6.89683L10.9156 2.43433C10.6594 2.27808 10.3406 2.27808 10.0844 2.43433L2.89687 6.89683V5.71558H2.89062Z",
    fill: "url(#paint8_radial_3786_77308)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_3786_77308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.53125 5.81171L7.5875 3.34546",
    stroke: "url(#paint9_linear_3786_77308)",
    strokeWidth: 0.3125,
    strokeLinecap: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_3786_77308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9375 1.60498L17.0225 5.37373",
    stroke: "url(#paint10_linear_3786_77308)",
    strokeWidth: 0.3125,
    strokeLinecap: "round"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 6.27173H4.25V16.8967H16.75V6.27173Z",
    fill: "#96919E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 6.27173H4.25V16.8967H16.75V6.27173Z",
    fill: "url(#paint11_linear_3786_77308)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 6.27173H4.25V16.8967H16.75V6.27173Z",
    fill: "url(#paint12_linear_3786_77308)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 6.27173H4.25V16.8967H16.75V6.27173Z",
    fill: "url(#paint13_linear_3786_77308)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8.56177H16.125V16.8824H18V8.56177Z",
    fill: "url(#paint14_linear_3786_77308)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8.56177H16.125V16.8824H18V8.56177Z",
    fill: "url(#paint15_linear_3786_77308)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8.56177H16.125V16.8824H18V8.56177Z",
    fill: "url(#paint16_linear_3786_77308)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8.56177H16.125V16.8824H18V8.56177Z",
    fill: "url(#paint17_radial_3786_77308)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 8.57617H13.625V16.8968H15.5V8.57617Z",
    fill: "url(#paint18_linear_3786_77308)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 8.57617H13.625V16.8968H15.5V8.57617Z",
    fill: "url(#paint19_linear_3786_77308)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 8.57617H13.625V16.8968H15.5V8.57617Z",
    fill: "url(#paint20_linear_3786_77308)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 8.57617H13.625V16.8968H15.5V8.57617Z",
    fill: "url(#paint21_radial_3786_77308)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M7.375 8.57617H5.5V16.7549H7.375V8.57617Z",
    fill: "url(#paint22_linear_3786_77308)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M7.375 8.57617H5.5V16.7549H7.375V8.57617Z",
    fill: "url(#paint23_linear_3786_77308)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M7.375 8.57617H5.5V16.7549H7.375V8.57617Z",
    fill: "url(#paint24_linear_3786_77308)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M7.375 8.57617H5.5V16.7549H7.375V8.57617Z",
    fill: "url(#paint25_linear_3786_77308)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M7.375 8.57617H5.5V16.7549H7.375V8.57617Z",
    fill: "url(#paint26_radial_3786_77308)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M4.875 8.57617H3V16.7549H4.875V8.57617Z",
    fill: "url(#paint27_linear_3786_77308)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M4.875 8.57617H3V16.7549H4.875V8.57617Z",
    fill: "url(#paint28_linear_3786_77308)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M4.875 8.57617H3V16.7549H4.875V8.57617Z",
    fill: "url(#paint29_linear_3786_77308)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M4.875 8.57617H3V16.7549H4.875V8.57617Z",
    fill: "url(#paint30_radial_3786_77308)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M18.625 8.56182V6.89307H2.375V8.56182H18.625Z",
    fill: "url(#paint31_linear_3786_77308)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M18.625 8.56182V6.89307H2.375V8.56182H18.625Z",
    fill: "url(#paint32_linear_3786_77308)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M18.625 8.56182V6.89307H2.375V8.56182H18.625Z",
    fill: "url(#paint33_linear_3786_77308)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M18.625 8.56182V6.89307H2.375V8.56182H18.625Z",
    fill: "url(#paint34_radial_3786_77308)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M18.625 8.56182V6.89307H2.375V8.56182H18.625Z",
    fill: "url(#paint35_linear_3786_77308)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M18.625 8.56182V6.89307H2.375V8.56182H18.625Z",
    fill: "url(#paint36_linear_3786_77308)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 6.27173C1.75 5.92798 2.03125 5.64673 2.375 5.64673H18.625C18.9688 5.64673 19.25 5.92798 19.25 6.27173C19.25 6.61548 18.9688 6.89673 18.625 6.89673H2.375C2.03125 6.89673 1.75 6.61548 1.75 6.27173Z",
    fill: "url(#paint37_linear_3786_77308)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 6.27173C1.75 5.92798 2.03125 5.64673 2.375 5.64673H18.625C18.9688 5.64673 19.25 5.92798 19.25 6.27173C19.25 6.61548 18.9688 6.89673 18.625 6.89673H2.375C2.03125 6.89673 1.75 6.61548 1.75 6.27173Z",
    fill: "url(#paint38_linear_3786_77308)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 6.27173C1.75 5.92798 2.03125 5.64673 2.375 5.64673H18.625C18.9688 5.64673 19.25 5.92798 19.25 6.27173C19.25 6.61548 18.9688 6.89673 18.625 6.89673H2.375C2.03125 6.89673 1.75 6.61548 1.75 6.27173Z",
    fill: "url(#paint39_linear_3786_77308)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 6.27173C1.75 5.92798 2.03125 5.64673 2.375 5.64673H18.625C18.9688 5.64673 19.25 5.92798 19.25 6.27173C19.25 6.61548 18.9688 6.89673 18.625 6.89673H2.375C2.03125 6.89673 1.75 6.61548 1.75 6.27173Z",
    fill: "url(#paint40_linear_3786_77308)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 6.27173C1.75 5.92798 2.03125 5.64673 2.375 5.64673H18.625C18.9688 5.64673 19.25 5.92798 19.25 6.27173C19.25 6.61548 18.9688 6.89673 18.625 6.89673H2.375C2.03125 6.89673 1.75 6.61548 1.75 6.27173Z",
    fill: "url(#paint41_radial_3786_77308)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 6.27173C1.75 5.92798 2.03125 5.64673 2.375 5.64673H18.625C18.9688 5.64673 19.25 5.92798 19.25 6.27173C19.25 6.61548 18.9688 6.89673 18.625 6.89673H2.375C2.03125 6.89673 1.75 6.61548 1.75 6.27173Z",
    fill: "url(#paint42_radial_3786_77308)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 6.27173C1.75 5.92798 2.03125 5.64673 2.375 5.64673H18.625C18.9688 5.64673 19.25 5.92798 19.25 6.27173C19.25 6.61548 18.9688 6.89673 18.625 6.89673H2.375C2.03125 6.89673 1.75 6.61548 1.75 6.27173Z",
    fill: "url(#paint43_radial_3786_77308)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_3786_77308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.75 8.77173C1.75 8.42798 2.03125 8.14673 2.375 8.14673H18.625C18.9688 8.14673 19.25 8.42798 19.25 8.77173C19.25 9.11548 18.9688 9.39673 18.625 9.39673H2.375C2.03125 9.39673 1.75 9.11548 1.75 8.77173Z",
    fill: "url(#paint44_linear_3786_77308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.75 8.77173C1.75 8.42798 2.03125 8.14673 2.375 8.14673H18.625C18.9688 8.14673 19.25 8.42798 19.25 8.77173C19.25 9.11548 18.9688 9.39673 18.625 9.39673H2.375C2.03125 9.39673 1.75 9.11548 1.75 8.77173Z",
    fill: "url(#paint45_linear_3786_77308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.75 8.77173C1.75 8.42798 2.03125 8.14673 2.375 8.14673H18.625C18.9688 8.14673 19.25 8.42798 19.25 8.77173C19.25 9.11548 18.9688 9.39673 18.625 9.39673H2.375C2.03125 9.39673 1.75 9.11548 1.75 8.77173Z",
    fill: "url(#paint46_linear_3786_77308)"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 8.77173C1.75 8.42798 2.03125 8.14673 2.375 8.14673H18.625C18.9688 8.14673 19.25 8.42798 19.25 8.77173C19.25 9.11548 18.9688 9.39673 18.625 9.39673H2.375C2.03125 9.39673 1.75 9.11548 1.75 8.77173Z",
    fill: "url(#paint47_radial_3786_77308)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 8.77173C1.75 8.42798 2.03125 8.14673 2.375 8.14673H18.625C18.9688 8.14673 19.25 8.42798 19.25 8.77173C19.25 9.11548 18.9688 9.39673 18.625 9.39673H2.375C2.03125 9.39673 1.75 9.11548 1.75 8.77173Z",
    fill: "url(#paint48_radial_3786_77308)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 18.1467H1.75V17.5655C1.75 17.1967 2.05 16.8967 2.41875 16.8967H18.575C18.9438 16.8967 19.2437 17.1967 19.2437 17.5655V18.1467H19.25Z",
    fill: "url(#paint49_linear_3786_77308)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 18.1467H1.75V17.5655C1.75 17.1967 2.05 16.8967 2.41875 16.8967H18.575C18.9438 16.8967 19.2437 17.1967 19.2437 17.5655V18.1467H19.25Z",
    fill: "url(#paint50_linear_3786_77308)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 18.1467H1.75V17.5655C1.75 17.1967 2.05 16.8967 2.41875 16.8967H18.575C18.9438 16.8967 19.2437 17.1967 19.2437 17.5655V18.1467H19.25Z",
    fill: "url(#paint51_linear_3786_77308)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 18.1467H1.75V17.5655C1.75 17.1967 2.05 16.8967 2.41875 16.8967H18.575C18.9438 16.8967 19.2437 17.1967 19.2437 17.5655V18.1467H19.25Z",
    fill: "url(#paint52_linear_3786_77308)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_3786_77308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.375 15.6467H8.625V11.6655C8.625 11.4467 8.8 11.2717 9.01875 11.2717H11.975C12.1938 11.2717 12.375 11.453 12.375 11.6717V15.6467Z",
    fill: "#4B4258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.375 15.6467H8.625V11.6655C8.625 11.4467 8.8 11.2717 9.01875 11.2717H11.975C12.1938 11.2717 12.375 11.453 12.375 11.6717V15.6467Z",
    fill: "url(#paint53_linear_3786_77308)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_ii_3786_77308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4906 8.14678C11.3211 8.14678 12.1175 7.81688 12.7048 7.22966C13.292 6.64243 13.6219 5.84599 13.6219 5.01553C13.6219 4.18507 13.292 3.38862 12.7048 2.8014C12.1175 2.21418 11.3211 1.88428 10.4906 1.88428C9.66017 1.88428 8.86372 2.21418 8.2765 2.8014C7.68927 3.38862 7.35938 4.18507 7.35938 5.01553C7.35938 5.84599 7.68927 6.64243 8.2765 7.22966C8.86372 7.81688 9.66017 8.14678 10.4906 8.14678Z",
    fill: "#B2ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4906 8.14678C11.3211 8.14678 12.1175 7.81688 12.7048 7.22966C13.292 6.64243 13.6219 5.84599 13.6219 5.01553C13.6219 4.18507 13.292 3.38862 12.7048 2.8014C12.1175 2.21418 11.3211 1.88428 10.4906 1.88428C9.66017 1.88428 8.86372 2.21418 8.2765 2.8014C7.68927 3.38862 7.35938 4.18507 7.35938 5.01553C7.35938 5.84599 7.68927 6.64243 8.2765 7.22966C8.86372 7.81688 9.66017 8.14678 10.4906 8.14678Z",
    fill: "url(#paint54_radial_3786_77308)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_3786_77308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3458 5.5L9.67075 4.3225V4.045H9.89575C9.98575 4.045 10.0645 4.0325 10.132 4.0075C10.202 3.98 10.2595 3.94125 10.3045 3.89125C10.352 3.84125 10.3845 3.78125 10.402 3.71125H9.67075V3.43375H10.3983C10.3833 3.36875 10.357 3.31125 10.3195 3.26125C10.2845 3.21125 10.237 3.1725 10.177 3.145C10.1195 3.115 10.0495 3.1 9.967 3.1H9.67075V2.8225H11.362V3.1H10.7733C10.8158 3.1475 10.8508 3.19875 10.8783 3.25375C10.9083 3.30875 10.9283 3.36875 10.9383 3.43375H11.362V3.71125H10.9458C10.9208 3.89625 10.8495 4.04125 10.732 4.14625C10.6145 4.24875 10.4633 4.31875 10.2783 4.35625L11.0133 5.5H10.3458Z",
    fill: "#6A6177"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_i_3786_77308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3458 6.5L9.67075 5.3225V5.045H9.89575C9.98575 5.045 10.0645 5.0325 10.132 5.0075C10.202 4.98 10.2595 4.94125 10.3045 4.89125C10.352 4.84125 10.3845 4.78125 10.402 4.71125H9.67075V4.43375H10.3983C10.3833 4.36875 10.357 4.31125 10.3195 4.26125C10.2845 4.21125 10.237 4.1725 10.177 4.145C10.1195 4.115 10.0495 4.1 9.967 4.1H9.67075V3.8225H11.362V4.1H10.7733C10.8158 4.1475 10.8508 4.19875 10.8783 4.25375C10.9083 4.30875 10.9283 4.36875 10.9383 4.43375H11.362V4.71125H10.9458C10.9208 4.89625 10.8495 5.04125 10.732 5.14625C10.6145 5.24875 10.4633 5.31875 10.2783 5.35625L11.0133 6.5H10.3458Z",
    fill: "#734B9B"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_3786_77308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.04688 9.39673H4.56688V15.9649H4.04688V9.39673Z",
    fill: "url(#paint55_linear_3786_77308)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_3786_77308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5625 9.39673H15.0825V15.9649H14.5625V9.39673Z",
    fill: "url(#paint56_linear_3786_77308)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_3786_77308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.49219 9.39673H7.01219V15.9649H6.49219V9.39673Z",
    fill: "url(#paint57_linear_3786_77308)"
  }))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6281 16.8967H2.35938V16.3155C2.35938 15.9467 2.65937 15.6467 3.02812 15.6467H17.9594C18.3281 15.6467 18.6281 15.9467 18.6281 16.3155V16.8967Z",
    fill: "url(#paint58_linear_3786_77308)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6281 16.8967H2.35938V16.3155C2.35938 15.9467 2.65937 15.6467 3.02812 15.6467H17.9594C18.3281 15.6467 18.6281 15.9467 18.6281 16.3155V16.8967Z",
    fill: "url(#paint59_linear_3786_77308)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6281 16.8967H2.35938V16.3155C2.35938 15.9467 2.65937 15.6467 3.02812 15.6467H17.9594C18.3281 15.6467 18.6281 15.9467 18.6281 16.3155V16.8967Z",
    fill: "url(#paint60_linear_3786_77308)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6281 16.8967H2.35938V16.3155C2.35938 15.9467 2.65937 15.6467 3.02812 15.6467H17.9594C18.3281 15.6467 18.6281 15.9467 18.6281 16.3155V16.8967Z",
    fill: "url(#paint61_linear_3786_77308)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6281 16.8967H2.35938V16.3155C2.35938 15.9467 2.65937 15.6467 3.02812 15.6467H17.9594C18.3281 15.6467 18.6281 15.9467 18.6281 16.3155V16.8967Z",
    fill: "url(#paint62_linear_3786_77308)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_3786_77308",
    x: 2.89062,
    y: 1.06714,
    width: 15.2109,
    height: 5.82959,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.1875
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.364706 0 0 0 0 0.352941 0 0 0 0 0.384314 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3786_77308"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3786_77308",
    x: 3.0625,
    y: 2.87671,
    width: 4.99219,
    height: 3.40381,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15625,
    result: "effect1_foregroundBlur_3786_77308"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_3786_77308",
    x: 10.4688,
    y: 1.13623,
    width: 7.02344,
    height: 4.7063,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15625,
    result: "effect1_foregroundBlur_3786_77308"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_3786_77308",
    x: 1.75,
    y: 8.14673,
    width: 17.75,
    height: 1.3125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.25,
    dy: 0.0625
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15625
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.505882 0 0 0 0 0.486275 0 0 0 0 0.521569 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3786_77308"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_3786_77308",
    x: 8.40625,
    y: 11.2717,
    width: 3.96875,
    height: 4.59375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.21875,
    dy: 0.21875
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.0784314 0 0 0 0 0.160784 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3786_77308"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_ii_3786_77308",
    x: 7.17187,
    y: 1.69678,
    width: 6.64063,
    height: 6.63745,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.1875,
    dy: 0.1875
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.3125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.917647 0 0 0 0 0.878431 0 0 0 0 0.937255 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3786_77308"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.1875,
    dy: -0.1875
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.3125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.454902 0 0 0 0 0.423529 0 0 0 0 0.501961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_3786_77308",
    result: "effect2_innerShadow_3786_77308"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_3786_77308",
    x: 9.39063,
    y: 2.54126,
    width: 2.25,
    height: 3.23999,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.140625,
    result: "effect1_foregroundBlur_3786_77308"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_3786_77308",
    x: 9.67188,
    y: 3.58813,
    width: 1.92188,
    height: 2.91187,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.234375,
    dy: -0.234375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.117188
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.333333 0 0 0 0 0.207843 0 0 0 0 0.47451 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3786_77308"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_3786_77308",
    x: 3.57812,
    y: 8.92798,
    width: 1.46094,
    height: 7.50562,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.234375,
    result: "effect1_foregroundBlur_3786_77308"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_3786_77308",
    x: 14.0938,
    y: 8.92798,
    width: 1.46094,
    height: 7.50562,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.234375,
    result: "effect1_foregroundBlur_3786_77308"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_3786_77308",
    x: 6.02344,
    y: 8.92798,
    width: 1.46094,
    height: 7.50562,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.234375,
    result: "effect1_foregroundBlur_3786_77308"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3786_77308",
    x1: 14.4456,
    y1: 5.16115,
    x2: 6.4375,
    y2: 5.16115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E98A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#847E89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3786_77308",
    x1: 14.2269,
    y1: 4.2399,
    x2: 13.9356,
    y2: 4.70678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#56525D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56525D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3786_77308",
    x1: 6.90625,
    y1: 4.15178,
    x2: 7.11625,
    y2: 4.50365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#56525D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56525D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_3786_77308",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.15125 5.15865) rotate(175.914) scale(1.53502 3.22982)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.349,
    stopColor: "#605D64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#605D64",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3786_77308",
    x1: 12.2025,
    y1: 6.0874,
    x2: 12.2025,
    y2: 5.52928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D6870",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3786_77308",
    x1: 4.54313,
    y1: 4.07558,
    x2: 18.2688,
    y2: 4.07558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7A0AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3786_77308",
    x1: 14.7,
    y1: 3.50808,
    x2: 14.2869,
    y2: 4.17183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD2E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBD2E0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_3786_77308",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.4969 2.2212) rotate(90) scale(0.732425 1.08924)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D797E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E97A1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_3786_77308",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.59177 4.57157) rotate(-138.844) scale(1.7775 2.07946)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.451,
    stopColor: "#605C64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#605C64",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3786_77308",
    x1: 3.53125,
    y1: 5.81171,
    x2: 7.71937,
    y2: 3.10546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2AAB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2AAB8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3786_77308",
    x1: 10.9375,
    y1: 1.60498,
    x2: 17.1856,
    y2: 5.59873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDD3E1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#DDD3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822,
    stopColor: "#DDD3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDD3E1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3786_77308",
    x1: 15.2656,
    y1: 14.3405,
    x2: 12.6488,
    y2: 14.3405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.417,
    stopColor: "#56525D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55505C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3786_77308",
    x1: 4.93375,
    y1: 14.3405,
    x2: 7.7525,
    y2: 14.3405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B4750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B4750",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3786_77308",
    x1: 12.6488,
    y1: 9.1061,
    x2: 12.6488,
    y2: 10.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#645A6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#645A6D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3786_77308",
    x1: 16.125,
    y1: 12.7205,
    x2: 17.7656,
    y2: 12.7205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#726C75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFB7C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3786_77308",
    x1: 15.9119,
    y1: 12.3574,
    x2: 16.7419,
    y2: 12.3574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76727B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76727B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3786_77308",
    x1: 18.2194,
    y1: 12.1455,
    x2: 17.0625,
    y2: 12.1455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4DBEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4DBEA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_3786_77308",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.3031 14.8055) rotate(-90) scale(5.91018 4.02006)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.823,
    stopColor: "#655E71",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951,
    stopColor: "#655E71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3786_77308",
    x1: 13.625,
    y1: 12.7349,
    x2: 15.2656,
    y2: 12.7349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C8693"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E99A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3786_77308",
    x1: 13.4119,
    y1: 12.3724,
    x2: 14.2419,
    y2: 12.3724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76727B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76727B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3786_77308",
    x1: 15.7194,
    y1: 12.1605,
    x2: 15.0712,
    y2: 12.1605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A09AA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A09AA5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_3786_77308",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.8031 14.8199) rotate(-90) scale(5.91018 2.36843)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.782,
    stopColor: "#655E71",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#655E71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_3786_77308",
    x1: 4.76937,
    y1: 12.6643,
    x2: 6.64437,
    y2: 12.6643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3D3D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_3786_77308",
    x1: 5.5,
    y1: 12.6643,
    x2: 7.14062,
    y2: 12.6643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79747E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A09BA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_3786_77308",
    x1: 5.28625,
    y1: 12.3074,
    x2: 6.11687,
    y2: 12.3074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76727B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76727B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_3786_77308",
    x1: 7.59438,
    y1: 12.0993,
    x2: 6.70313,
    y2: 12.0993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8B1BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8B1BF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_3786_77308",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.67813 14.7137) rotate(-90) scale(5.80936 2.36843)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.782,
    stopColor: "#655E71",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#655E71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_3786_77308",
    x1: 3,
    y1: 12.6643,
    x2: 4.64062,
    y2: 12.6643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C8693"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E99A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_3786_77308",
    x1: 2.78625,
    y1: 12.3074,
    x2: 3.61687,
    y2: 12.3074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76727B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76727B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_3786_77308",
    x1: 5.09437,
    y1: 12.0993,
    x2: 4.44625,
    y2: 12.0993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A09AA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A09AA5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_3786_77308",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.17813 14.7137) rotate(-90) scale(5.80936 2.36843)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.782,
    stopColor: "#655E71",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#655E71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_3786_77308",
    x1: 4.41187,
    y1: 7.46619,
    x2: 18.625,
    y2: 7.46619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A59FAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFA8B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_3786_77308",
    x1: 10.5,
    y1: 6.89307,
    x2: 10.5,
    y2: 7.15119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#676071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#676071",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_3786_77308",
    x1: 2.24,
    y1: 7.57182,
    x2: 3.16438,
    y2: 7.57182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7881",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_3786_77308",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.05567 6.89319) rotate(128.212) scale(1.67346 3.37266)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.389,
    stopColor: "#645D6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#645D6E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_3786_77308",
    x1: 12.1806,
    y1: 8.56182,
    x2: 12.1806,
    y2: 7.99494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D5A61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D5A61",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_3786_77308",
    x1: 18.625,
    y1: 7.72744,
    x2: 18.1125,
    y2: 7.72744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBD2E1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_3786_77308",
    x1: 10.4988,
    y1: 5.64548,
    x2: 10.4988,
    y2: 6.89673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9C0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A09AAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_3786_77308",
    x1: 3.58625,
    y1: 6.89673,
    x2: 10.5,
    y2: 6.89673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0A8B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0A8B4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_3786_77308",
    x1: 9.7775,
    y1: 7.05548,
    x2: 9.7775,
    y2: 6.27173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C7586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C7586",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_3786_77308",
    x1: 1.75,
    y1: 6.27173,
    x2: 2.52125,
    y2: 6.27173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C7586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C7586",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_3786_77308",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.88312 5.81548) rotate(153.223) scale(1.01236 2.70689)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.211,
    stopColor: "#685F73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#685F73",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_3786_77308",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.68 4.95798) rotate(94.2362) scale(1.65894 8.76238)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBC3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBC3D2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_3786_77308",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.1575 5.8386) rotate(-38.2902) scale(0.741655 0.668567)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6EBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6EBFC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_3786_77308",
    x1: 10.4988,
    y1: 8.14548,
    x2: 10.4988,
    y2: 9.39673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#948B9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_3786_77308",
    x1: 1.55125,
    y1: 9.39673,
    x2: 2.40938,
    y2: 9.39673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79747E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79747E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_3786_77308",
    x1: 9.76625,
    y1: 9.77048,
    x2: 9.76625,
    y2: 8.94985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#787182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787182",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_3786_77308",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.1 7.37798) rotate(90) scale(1.32812 2.46377)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.571,
    stopColor: "#4E4B52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E6A72",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_3786_77308",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.1575 8.3386) rotate(-38.2902) scale(0.741655 0.668567)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6EBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6EBFC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_3786_77308",
    x1: 9.7725,
    y1: 16.8967,
    x2: 9.7725,
    y2: 18.1467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0B9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFB8C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_3786_77308",
    x1: 10.5,
    y1: 16.6324,
    x2: 10.5,
    y2: 17.6905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.708,
    stopColor: "#CBC3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBC3D2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_3786_77308",
    x1: 1.6725,
    y1: 18.1467,
    x2: 2.55313,
    y2: 18.1467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79737C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79737C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_3786_77308",
    x1: 19.6062,
    y1: 17.5217,
    x2: 18.3869,
    y2: 17.5217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_3786_77308",
    x1: 8.625,
    y1: 14.5592,
    x2: 9.3325,
    y2: 14.5592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F4461"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F4461",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_3786_77308",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.97 5.55303) rotate(-35.1806) scale(4.46771 4.46771)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.693,
    stopColor: "#EBE1F1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBE1F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_3786_77308",
    x1: 4.30688,
    y1: 15.0367,
    x2: 4.30688,
    y2: 6.77923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2C9D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2C9D7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_3786_77308",
    x1: 14.8225,
    y1: 15.0367,
    x2: 14.8225,
    y2: 6.77923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2C9D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2C9D7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_3786_77308",
    x1: 6.75219,
    y1: 15.0367,
    x2: 6.75219,
    y2: 6.77923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.331,
    stopColor: "#CEC5D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEC5D4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_3786_77308",
    x1: 9.8175,
    y1: 15.6467,
    x2: 9.8175,
    y2: 16.8967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0B9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFB8C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_3786_77308",
    x1: 10.4938,
    y1: 15.3824,
    x2: 10.4938,
    y2: 16.4405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.708,
    stopColor: "#CBC3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBC3D2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_3786_77308",
    x1: 2.2875,
    y1: 16.8967,
    x2: 3.10625,
    y2: 16.8967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79737C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79737C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_3786_77308",
    x1: 18.9594,
    y1: 16.2717,
    x2: 17.8256,
    y2: 16.2717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_3786_77308",
    x1: 10.4938,
    y1: 17.1724,
    x2: 10.4938,
    y2: 16.8211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#817B84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#817B84",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluentEmojiBank);
export default __webpack_public_path__ + "static/media/fluent-emoji_bank.2477b8298d0fc145fb35b722cb485eac.svg";
export { ForwardRef as ReactComponent };